import * as jwtDecode from 'jwt-decode';

// 解析 JWT
export function parseJwt(token) {
  try {
    // 注意这里调用方式的变化
    return jwtDecode.jwtDecode(token);
  } catch (error) {
    console.error('Invalid token:', error);
    return null;
  }
}